export const copyToClipboard = (value: string) => {
    const body = document.body;

    if (body) {
        const dummyEl = document.createElement('input');
        body.appendChild(dummyEl);
        dummyEl.setAttribute('value', value);
        dummyEl.select();
        document.execCommand('copy');
        body.removeChild(dummyEl);
    }
};
